export default __webpack_public_path__ + "static/Freight-SansMedium-4b33823b2b3bd6470ba896fde77d8f8d.woff";